import axios from '@/plugins/axios'
import _ from 'lodash'
import * as actionTypes from '@/store/action-types'
import * as mutationTypes from '@/store/mutation-types'
import { GlobalState, PeriodicityPlannedCalendarEventEmployee } from '@/types'
import {
  CalendarEventAssistantStartEndPayload,
  CreateCalendarEventSeriesRequest,
  PlanningAssistantPeriodicityPayload,
  UpdateCalendarEventSeriesRequest
} from '@/types/payload'
import {
  CalendarEventSerie, CreateCalendarEventSeriesResponse,
  GetCalendarEventTypesResponse,
} from '@/types/service-response'
import { ShiftEditorPlanningPayload } from '@/model/planning/ShiftEditorPlanningPayload'
import { EmployeeAvailableForPlanning } from '@/model/planning/EmployeeAvailableForPlanning'
import { Employee } from '@/model/companyStructure/Employee'
import { CalendarEventEmployee } from '@/model/calendarEvent/CalendarEventEmployee'


const calendarEventActions = {

  [actionTypes.CALENDAR_EVENT_ASSISTANT_RESET_STATE] ({ commit }: { commit: Function }): void {
    commit(mutationTypes.CALENDAR_EVENT_ASSISTANT_RESET_STATE_MUTATION)
  },

  [actionTypes.CALENDAR_EVENT_ASSISTANT_INIT_FROM_PAYLOAD] ({ commit }: { commit: Function }, payload: ShiftEditorPlanningPayload): void {
    commit(mutationTypes.CALENDAR_EVENT_ASSISTANT_SET_DATA_FROM_PAYLOAD_MUTATION, _.cloneDeep(payload))
  },

  [actionTypes.CALENDAR_EVENT_ASSISTANT_SET_START_END_DATA] ({ commit }: { commit: Function }, payload: CalendarEventAssistantStartEndPayload): void {
    commit(mutationTypes.CALENDAR_EVENT_ASSISTANT_SET_START_DATE_MUTATION, payload.dateStart)
    commit(mutationTypes.CALENDAR_EVENT_ASSISTANT_SET_END_DATE_MUTATION, payload.dateEnd)
    commit(mutationTypes.CALENDAR_EVENT_ASSISTANT_SET_CALENDAR_EVENT_ITEM_MUTATION, payload.calendarEventItem)
  },

  /*[actionTypes.ABSENCES_ASSISTANT_SET_ABSENCE_REASON_ITEM] ({ commit }: { commit: Function }, payload: AbsenceReason): void {
    commit(mutationTypes.ABSENCES_ASSISTANT_SET_ABSENCE_REASON_ITEM_MUTATION, payload)
  },*/

  [actionTypes.CALENDAR_EVENT_ASSISTANT_SET_EMPLOYEE_LIST_FOR_PLANNING] ({ commit }: { commit: Function }, payload: EmployeeAvailableForPlanning[]): void {
    commit(mutationTypes.CALENDAR_EVENT_ASSISTANT_SET_EMPLOYEE_LIST_FOR_PLANNING_MUTATION, payload)
  },

  [actionTypes.CALENDAR_EVENT_ASSISTANT_SET_PLANNED_EMPLOYEE_LIST] ({ commit }: { commit: Function }, payload: CalendarEventEmployee[]): void {
    commit(mutationTypes.CALENDAR_EVENT_ASSISTANT_SET_PLANNED_EMPLOYEE_LIST_MUTATION, payload)
  },

  [actionTypes.CALENDAR_EVENT_ASSISTANT_SET_PERIODICITY_PLANNED_EMPLOYEE_LIST] ({ commit }: { commit: Function }, payload: PeriodicityPlannedCalendarEventEmployee[]): void {
    commit(mutationTypes.CALENDAR_EVENT_ASSISTANT_SET_PERIODICITY_PLANNED_EMPLOYEE_LIST_MUTATION, payload)
  },

  [actionTypes.CALENDAR_EVENT_ASSISTANT_SET_FILTERED_EMPLOYEES_BY_DEPARTMENT] ({ commit }: { commit: Function }, payload: Employee[]): void {
    commit(mutationTypes.CALENDAR_EVENT_ASSISTANT_SET_FILTERED_EMPLOYEES_BY_DEPARTMENT_MUTATION, payload)
  },

  [actionTypes.CALENDAR_EVENT_ASSISTANT_SET_PERIODICITY] ({ commit }: { commit: Function }, payload: PlanningAssistantPeriodicityPayload): void {
    commit(mutationTypes.CALENDAR_EVENT_ASSISTANT_SET_PERIODICITY_MUTATION, payload)
  },

  [actionTypes.CALENDAR_EVENT_ASSISTANT_SET_IS_EDITING_SERIE] ({ commit }: { commit: Function }, payload: boolean): void {
    commit(mutationTypes.CALENDAR_EVENT_ASSISTANT_SET_IS_EDITING_SERIE_MUTATION, payload)
  },

  [actionTypes.CALENDAR_EVENT_ASSISTANT_SET_PERIODICITY_SERIE] ({ commit }: { commit: Function }, payload: CalendarEventSerie[] | undefined): void {
    commit(mutationTypes.CALENDAR_EVENT_ASSISTANT_SET_PERIODICITY_SERIE_MUTATION, payload)
  },

  async [actionTypes.LOAD_CALENDAR_EVENT_LIST] ({ rootState }: { rootState: GlobalState }, payload: number): Promise<GetCalendarEventTypesResponse> {
    const response = await axios.get('/api/KalenderArt/GetCalendarTypes', {
      params: {
        'profitCenter': payload,
        'sprache': rootState.selectedUiLanguage!.syzId
      }
    })

    return response.data
  },


  async [actionTypes.CREATE_CALENDAR_EVENT] ({ rootState }: { rootState: GlobalState }, payload: CreateCalendarEventSeriesRequest): Promise<CreateCalendarEventSeriesResponse> {
    const response = await axios.post('/api/KalenderArt/CreateCalendarEventSeries', payload)
    return response.data
  },

  async [actionTypes.EDIT_CALENDAR_EVENT] ({ rootState }: { rootState: GlobalState }, payload: UpdateCalendarEventSeriesRequest): Promise<any> {
    const response = await axios.post('/api/KalenderArt/UpdateCalendarEventSeries', payload)
    return response.data
  },

  async [actionTypes.FETCH_CALENDAR_EVENT_SERIES] ({ rootState }: { rootState: GlobalState }, payload: number): Promise<any[]> {
    const response = await axios.get('/api/KalenderArt/GetSeries', {
      params: {
        'seriesId': payload
      }
    })

    return response.data
  },


}

export default calendarEventActions
